import React from "react";
import "./bna.css";

const Bna = () => {
  return (
    <div className="bna-container">
      <div className="bna-title">
        <h2 className="bna-title-text">
          conoce algunos de los avances de nuestros pacientes
        </h2>
      </div>
      <div className="bna-imgs">
        <img className="bna-img" src="bna1.png" alt="bna" />
        <img className="bna-img" src="bna2.png" alt="bna" />
      </div>
    </div>
  );
};

export default Bna;
